<template>
    <div class="nav_wrap_mobile">
        <div class="top">
            <router-link class="logo" to="/"></router-link>
            <div class="switch" :class="{open: isShow, close: isShow != null && !isShow}" @click="isShow = !isShow"><span></span></div>
        </div>
        <template v-if="config.menus">
            <div class="nav" :class="{active: isShow}">
                <div class="item">
                    <router-link class="name" to="/"><span>{{$t('home')}}</span></router-link>
                </div>
                <div class="item" v-for="item in config.menus" :key="item.id">
                    <p class="name" v-if="item.type == 0"><span>{{item.name}}</span></p>
                    <router-link class="name" v-else-if="item.type == 1" :to="`/detail/${item.id}`"><span>{{item.name}}</span></router-link>
                    <router-link class="name" v-else-if="item.type == 2" :to="`/list/${item.id}`"><span>{{item.name}}</span></router-link>
                    <router-link class="name" v-else-if="item.type == 3" :to="`/repair/${item.id}`"><span>{{item.name}}</span></router-link>
                    <router-link class="name" v-else-if="item.type == 4" :to="`/message/${item.id}`"><span>{{item.name}}</span></router-link>
                    <router-link class="name" v-else-if="item.type == 5" :to="`/contact/${item.id}`"><span>{{item.name}}</span></router-link>
                    <router-link class="name" v-else-if="item.type == 6" :to="`/photo/${item.id}`"><span>{{item.name}}</span></router-link>

                    <!-- <router-link class="name" v-else to="/">{{item.name}}</router-link> -->
                    <div class="list" v-if="item.list.length > 0">
                        <template v-for="_item in item.list">
                            <router-link class="link" :key="_item.id" v-if="_item.type == 1" :to="`/detail/${_item.id}`"><span>{{_item.name}}</span></router-link>
                            <router-link class="link" :key="_item.id" v-else-if="_item.type == 2" :to="`/list/${_item.id}`"><span>{{_item.name}}</span></router-link>
                            <router-link class="link" :key="_item.id" v-else-if="_item.type == 3" :to="`/repair/${_item.id}`"><span>{{_item.name}}</span></router-link>
                            <router-link class="link" :key="_item.id" v-else-if="_item.type == 4" :to="`/message/${_item.id}`"><span>{{_item.name}}</span></router-link>
                            <router-link class="link" :key="_item.id" v-else-if="_item.type == 5" :to="`/contact/${_item.id}`"><span>{{_item.name}}</span></router-link>
                            <router-link class="link" :key="_item.id" v-else-if="_item.type == 6" :to="`/photo/${_item.id}`"><span>{{_item.name}}</span></router-link>

                            <!-- <router-link class="link" :key="_item.id" v-else :to="`/`">{{_item.name}}</router-link> -->
                        </template>
                    </div>
                </div>
                <div class="item">
                    <a :href="($i18n.locale == 'zh' ? '/ru/#' : '/#') + $route.fullPath">中文 | русск</a>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "navigationMobile",
    data() {
        return {
            isShow: null,
        };
    },
    computed: {
        ...mapState(['config']),
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        '$route.path': function(){
            this.isShow = false;
        }
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.nav_wrap_mobile{
    height: 1rem;
    position: relative;
    z-index: 9;
    .top{
        width: 100%;
        height: 1rem;
        position: fixed;
        top: 0;
        left: 0;
        background: #fff;
        .logo{
            width: 50%;
            height: 100%;
            display: block;
            background: url('~@/assets/images/mlogo.png') no-repeat center;
            background-size: auto 100%;
            margin: 0 auto;
        }
        .switch{
            position: absolute;
            top: 0;
            left: 0;
            width: 1rem;
            height: 1rem;
            &::before,
            &::after,
            span{
                content: "";
                display: block;
                width: 50%;
                border-bottom: 1px solid #000;
                transition: opacity .5s;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            &::before{
                transform: translate(-50%, calc(-50% - .1rem));
            }
            &::after{
                transform: translate(-50%, calc(-50% + .1rem));
            }
            &.open{
                span{
                    opacity: 0;
                }
                &::before{
                    animation: beforeOpen .5s both;
                    @keyframes beforeOpen {
                        0%{ transform: translate(-50%, calc(-50% - .1rem)) }
                        50%{ transform: translate(-50%, -50%) }
                        100%{ transform: translate(-50%, -50%) rotate(45deg) }
                    }
                }
                &::after{
                    animation: afterOpen .5s both;
                    @keyframes afterOpen {
                        0%{ transform: translate(-50%, calc(-50% + .1rem)) }
                        50%{ transform: translate(-50%, -50%) }
                        100%{ transform: translate(-50%, -50%) rotate(-45deg) }
                    }
                }
            }
            &.close{
                span{
                    opacity: 1;
                }
                &::before{
                    animation: beforeClose .5s both;
                    @keyframes beforeClose {
                        0%{ transform: translate(-50%, -50%) rotate(45deg) }
                        50%{ transform: translate(-50%, -50%) }
                        100%{ transform: translate(-50%, calc(-50% - .1rem)) }
                    }
                }
                &::after{
                    animation: afterClose .5s both;
                    @keyframes afterClose {
                        0%{ transform: translate(-50%, -50%) rotate(-45deg) }
                        50%{ transform: translate(-50%, -50%) }
                        100%{ transform: translate(-50%, calc(-50% + .1rem)) }
                    }
                }
            }
        }
    }
    .nav{
        position: fixed;
        background: rgba($color: #000000, $alpha: .8);
        top: 1rem;
        left: 0;
        bottom: 100%;
        width: 100%;
        color: #fff;
        overflow: hidden;
        transition: bottom .5s;
        &.active{
            bottom: 0;
        }
        .item{
            border-bottom: 1px solid #777777;
            padding-left: .4rem;
            padding-bottom: .1rem;
            margin-bottom: .1rem;
            &:first-child{
                padding-top: .1rem;
            }
            .list{
                font-size: .28rem;
                display: flex;
                flex-wrap: wrap;
                text-align: center;
                // padding-top: .1rem;
                .link{
                    width: 33.33%;
                    margin-top: .1rem;
                }
            }
        }
    }
}
</style>